import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z} from "zod";
import {configEventContainerListHref} from "~/workspaceConfig/configHref";

export const CUSTOMER_PROFILE_FROM = {
    customers: "customers",
} as const;

export const customerProfileSearchSchema = z.object({
    from: z.string().optional(),
});

export type CustomerProfileSearch = z.infer<typeof customerProfileSearchSchema>;

export function buildCustomerProfileNavigateSearch(from: string): CustomerProfileSearch {
    return {from};
}

export function resolveCustomerProfileBreadcrumbs(args: {
    from: string | undefined;
    workspaceId: Uuid;
    customersPluralLabel: string;
    customersSingularLabel: string;
}): Array<{displayName: string; to: string | null}> {
    return [
        {
            displayName: args.customersPluralLabel,
            to: configEventContainerListHref(args.workspaceId),
        },
        {
            displayName: `${args.customersSingularLabel} profile`,
            to: null,
        },
    ];
}
